// libs
import React, { useRef, useMemo, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { decodeText, encodeText } from '@aytm/app/stats/lib/helpers'

// components
import { InputTextarea } from 'primereact/inputtextarea'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/QuestionTitle.module.scss'

const MAX_TITLE_LENGTH = 240

const onKeyDown = event => 13 == event.keyCode && event.preventDefault()

// TODO remove window.StatPage.model
const QuestionTitle = ({ question, title, editing, disabled, setTitle }) => {
  const callbackRef = useRef(null)

  const questionTitle = useMemo(
    () =>
      ['dlv', 'dlc', 'dlx', 'dld', 'dlt'].includes(question.type)
        ? question.text.length
          ? `${question.text}${question.textAppendix ? ' ' + question.textAppendix : ''}`
          : 'New custom chart'
        : window.StatPage.model.processText(('string' == typeof question.header && question.header) || question.text),
    [question.header, question.text, question.textAppendix, question.type]
  )

  const onChange = useCallback(
    event => {
      const text = encodeText(event.target.value)
      if (title == text) return

      setTitle(text)
    },
    [title, setTitle]
  )

  const onPaste = useCallback(
    event => {
      event.preventDefault()

      let text =
        (event.clipboardData || window.clipboardData).getData('Text') || event.clipboardData.getData('text/plain')
      text = text.replace(/(\r\n|\n|\r|\t|\v)/gm, ' ').trim()

      const el = event.currentTarget

      const l = text.length
      const start = el.selectionStart
      const end = el.selectionEnd

      const valueBefore = el.value.slice(0, start)
      const valueAfter = el.value.slice(end)
      text = encodeText(`${valueBefore}${text}${valueAfter}`.slice(0, MAX_TITLE_LENGTH))

      if (title != text) setTitle(text)

      callbackRef.current = () => {
        el.setSelectionRange(start + l, start + l)
        el.blur()
        el.focus()
      }
    },
    [title, setTitle]
  )

  useEffect(() => {
    if (null !== callbackRef.current && 'function' == typeof callbackRef.current) {
      callbackRef.current()
      callbackRef.current = null
    }
  }, [title])

  return editing && !disabled ? (
    <div className={`p-fluid`} key="question-title">
      <InputTextarea
        id={`title-${question.id}`}
        className={`${style.title}${!title.trim().length ? ' p-invalid' : ''}`}
        value={decodeText(title)}
        placeholder="Full title for reporting purposes"
        maxLength={MAX_TITLE_LENGTH}
        rows={1}
        autoResize={true}
        autoFocus
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
      />
    </div>
  ) : (
    <div className={style.text} dangerouslySetInnerHTML={{ __html: questionTitle }} />
  )
}

QuestionTitle.propTypes = {
  question: PropTypes.object,
  title: PropTypes.string,
  editing: PropTypes.bool,
  disabled: PropTypes.bool,
  setTitle: PropTypes.func
}

QuestionTitle.displayName = 'QuestionTitle'

export default QuestionTitle
